/**
 * Header component.
 * @module components/theme/Header/Header
 *
 * Customization of `@plone/volto/src/components/theme/Header/Header`:
 * - custom branded markup (`header-kg`) styled by `Header.scss`, replacing the
 *   Semantic UI `Segment`/`Container` structure of core;
 * - keeps the core behaviour (subcomponents and `Anontools` only for
 *   anonymous users).
 */
import './Header.scss';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';

import Anontools from '@plone/volto/components/theme/Anontools/Anontools';
import LanguageSelector from '@plone/volto/components/theme/LanguageSelector/LanguageSelector';
import Logo from '@plone/volto/components/theme/Logo/Logo';
import Navigation from '@plone/volto/components/theme/Navigation/Navigation';
import SearchWidget from '@plone/volto/components/theme/SearchWidget/SearchWidget';

const Header = ({ pathname }) => {
  const token = useSelector((state) => state.userSession.token, shallowEqual);

  return (
    <header role="banner" className="header-kg header-wrapper">
      <div className="container">
        <Logo />
        <nav>
          <Navigation pathname={pathname} />
        </nav>
        <aside>
          <LanguageSelector />
          <SearchWidget />
          {!token && (
            <div className="tools">
              <Anontools />
            </div>
          )}
        </aside>
      </div>
    </header>
  );
};

export default Header;

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  content: PropTypes.objectOf(PropTypes.any),
};

Header.defaultProps = {
  token: null,
  content: null,
};
